export const SIGN_IN = 'SIGN_IN';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const LOG_OUT = 'LOG_OUT';
export const FORGET_PASSWORD_UPDATE = 'FORGET_PASSWORD_UPDATE';
